var map = {
	"./dangan.png": "59f7",
	"./doc.png": "46e1",
	"./docx.png": "ed1f",
	"./gif.png": "2a35",
	"./home_huatiicon.png": "43bf",
	"./home_msgzs_huangguan.png": "f802",
	"./home_zhibo_ing.png": "6e74",
	"./jiaoshi-icon.png": "7237",
	"./jiaoxue-icon.png": "d8f9",
	"./jpeg.png": "e3da",
	"./jpg.png": "7040",
	"./mp3.png": "9f25",
	"./mp4.png": "607c",
	"./msgzs_hzsj_icon01.png": "dcfe",
	"./msgzs_hzsj_icon02.png": "c9f1",
	"./msgzs_hzsj_icon03.png": "b930",
	"./msgzs_hzsj_icon04.png": "dc1f",
	"./msgzs_hzsj_icon05.png": "fb04",
	"./msgzs_hzsj_icon06.png": "f579",
	"./other.png": "84f7",
	"./pdf.png": "d190",
	"./peixun-icon.png": "2fee",
	"./png.png": "4ec8",
	"./ppt.png": "1c07",
	"./pptx.png": "7cd5",
	"./txt.png": "e990",
	"./wenzhang1.png": "e585",
	"./wenzhang2.png": "3b7f",
	"./wenzhang3.png": "952d",
	"./wenzhang4.png": "2580",
	"./xiaoxi-icon.png": "d18c",
	"./xinwen-icon.png": "6476",
	"./xls.png": "6e81",
	"./xlsx.png": "742f2",
	"./yingyong-icon.png": "84bc",
	"./zhexian-icon.png": "9849",
	"./zhuzhuang-icon.png": "6e02",
	"./zip.png": "4467",
	"./ziyuan-icon.png": "b8c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9f0";